// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"1ffd2ad8","139":"6bca0b37","191":"d15b7468","782":"581dde11","787":"68b05114"}[chunkId] + ".chunk.js";
};